module.exports = __webpack_public_path__ + "static/media/021-snowing-3.c8ce7671.svg";